import React from "react";
import { connect } from "react-redux";
import { Field, formValueSelector, reduxForm, change } from "redux-form";
import _ from "lodash";
import { Link } from "react-router";
import Title from "../../components/Layout/Title";
import { UF_SYSTEM_LOAD, CONFIRM_ACTION_OPEN, CONTACT_DETRAN_LIST_LOAD, CONTACT_DETRAN_LIST_UNLOAD } from "../../actions/Constants";
import api from "../../api/apiUtil";
import SelectField from "../../components/Fields/SelectField";
import FieldValidation from "../../components/Validation/FieldValidation";
import FieldNormalize from "../../components/Normalize/FieldNormalize";
import TextField from "../../components/Fields/TextField";
import TextareaField from "../../components/Fields/TextareaField";
import { toastr } from "react-redux-toastr";

class ContatosDetran extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contact: null,
    };
  }

  componentDidMount() {
    this.props.onUfSystemLoad(api.Ufs.sigla_system());
  }

  componentWillUnmount() {
    this.props.onContactsUnload();
  }

  recuperaValores(event) {
    this.props.onContactsLoad(Promise.resolve(api.Detrans.allContacts(event.target.value)));
    this.handleOnCancelContacts();
  }

  formSubmitContact = (values) => {
    let props = this.props;
    if (
      (!values.nome || values.nome.length === 0 || !values.nome.trim()) &&
      (!values.email || values.email.length === 0 || !values.email.trim()) &&
      (!values.dddTelefone || values.dddTelefone.length === 0 || !values.dddTelefone.trim()) &&
      (!values.numTelefone || values.numTelefone.length === 0 || !values.numTelefone.trim()) &&
      (!values.setor || values.setor.length === 0 || !values.setor.trim()) &&
      (!values.observacoes || values.observacoes.length === 0 || !values.observacoes.trim())
    ) {
      toastr.warning("Atenção", "É obrigatório informar algum campo do contato.");
      return;
    }
    var contact = {
      uf: props.selectedUf,
      nome: values.nome,
      email: values.email,
      dddTelefone: values.dddTelefone,
      numTelefone: values.numTelefone,
      setor: values.setor,
      observacoes: values.observacoes,
    };
    if (this.state.contact) {
      contact.id = this.state.contact.id;
      Promise.resolve(api.Detrans.updateContact(contact))
        .then((ret) => {
          toastr.success("Sucesso", "Contato alterado.");
          this.props.onContactsLoad(Promise.resolve(api.Detrans.allContacts(props.selectedUf)));
          this.handleOnCancelContacts();
        })
        .catch(function (resp) {
          if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else {
            toastr.error("Erro", resp.response.body.message);
          }
        });
    } else {
      Promise.resolve(api.Detrans.createContact(contact))
        .then((ret) => {
          toastr.success("Sucesso", "Contato cadastrado.");
          this.props.onContactsLoad(Promise.resolve(api.Detrans.allContacts(props.selectedUf)));
          this.handleOnCancelContacts();
        })
        .catch(function (resp) {
          if (resp === "Unauthorized" || resp === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else {
            toastr.error("Erro", resp.response.body.message);
          }
        });
    }
  };

  handleOnSelectContactClick = (data) => {
    this.setState({ contact: data });
    this.props.dispatch(change("ContatosDetranForm", "nome", data.nome));
    this.props.dispatch(change("ContatosDetranForm", "email", data.email));
    this.props.dispatch(change("ContatosDetranForm", "dddTelefone", data.dddTelefone));
    this.props.dispatch(change("ContatosDetranForm", "numTelefone", data.numTelefone));
    this.props.dispatch(change("ContatosDetranForm", "setor", data.setor));
    this.props.dispatch(change("ContatosDetranForm", "observacoes", data.observacoes));
  };

  handleOnCancelContacts = () => {
    this.setState({ contact: null });
    this.props.dispatch(change("ContatosDetranForm", "nome", null));
    this.props.dispatch(change("ContatosDetranForm", "email", null));
    this.props.dispatch(change("ContatosDetranForm", "dddTelefone", null));
    this.props.dispatch(change("ContatosDetranForm", "numTelefone", null));
    this.props.dispatch(change("ContatosDetranForm", "setor", null));
    this.props.dispatch(change("ContatosDetranForm", "observacoes", null));
  };

  onActionDelete() {
    this.props.onActionOpen({
      description: `Confirma a exclusão do contato?`,
      onSuccess: this.deleteContact.bind(this),
    });
  }

  deleteContact() {
    var props = this.props;
    Promise.resolve(api.Detrans.deleteContact(this.state.contact.id))
      .then((ret) => {
        this.props.onContactsLoad(Promise.resolve(api.Detrans.allContacts(props.selectedUf)));
        this.setState({ contact: null });
        toastr.success("Sucesso", "Contato excluído.");
      })
      .catch(function (resp) {
        if (resp === "Unauthorized" || resp === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="Gestão de contatos com detran" />
        <div className="content">
          <div className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                <div className="row">
                  <div className="col-md-2">
                    <Field name="uf" label="Selecione a UF" data={this.props.ufSystem} blank={true} textField="sigla" component={SelectField} type="text" onChange={this.recuperaValores.bind(this)} />
                  </div>
                </div>
                {this.props.selectedUf && (
                  <div className="panel-body">
                    {this.props.currentUser.funcionalidades.includes(97) && (
                      <form className="form-horizontal" onSubmit={handleSubmit(this.formSubmitContact.bind(this))}>
                        <div className="row">
                          <div className="col-md-4">
                            <Field name="nome" label="Nome" component={TextField} type="text" />
                          </div>
                          <div className="col-md-3">
                            <Field name="email" label="E-mail" component={TextField} type="text" validate={[FieldValidation.email]} />
                          </div>
                          <div className="col-md-1">
                            <Field name="dddTelefone" label="DDD" normalize={FieldNormalize.NUMBER} component={TextField} type="text" maxlength={2} />
                          </div>
                          <div className="col-md-2">
                            <Field name="numTelefone" label="Telefone" normalize={FieldNormalize.PHONE_N_DDD} component={TextField} type="text" />
                          </div>
                          <div className="col-md-2">
                            <Field name="setor" label="Setor" component={TextField} type="text" />
                          </div>
                          <div className="col-md-12">
                            <Field name="observacoes" label="Observação" component={TextareaField} type="text" rows={3} />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <div className="text-right">
                              <Link className="btn btn-default" onClick={() => this.handleOnCancelContacts()}>
                                Cancelar
                              </Link>
                              <button type="submit" className="btn btn-info">
                                {" "}
                                {this.state.contact ? "Alterar" : "Adicionar"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    )}
                    <hr></hr>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="hpanel">
                          <div className="panel-heading">Contatos cadastrados</div>
                          <div className="panel-body">
                            <div className="table-responsive">
                              {this.props.contacts && this.props.contacts.length > 0 ? (
                                <table cellPadding="1" cellSpacing="1" className="table table-bordered table-striped">
                                  <thead>
                                    <tr>
                                      <th className="text-center align-middle">NOME</th>
                                      <th className="text-center align-middle">EMAIL</th>
                                      <th className="text-center align-middle">TELEFONE</th>
                                      <th className="text-center align-middle">SETOR</th>
                                      <th className="text-center align-middle">OBSERVAÇÃO</th>
                                      {this.props.currentUser.funcionalidades.includes(97) && <th className="text-center align-middle">AÇÕES</th>}
                                    </tr>
                                  </thead>
                                  <tbody>{this.renderListContacts()}</tbody>
                                </table>
                              ) : (
                                <small>Nenhum registro encontrado</small>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderListContacts() {
    if (!this.props.contacts) {
      return null;
    }
    return this.props.contacts.map((contact, index) => {
      return (
        <tr key={index}>
          <td className="text-center align-middle">{contact.nome ? contact.nome : "Não informado"}</td>
          <td className="text-center align-middle">{contact.email ? contact.email : "Não informado"}</td>
          <td className="text-center align-middle">{contact.dddTelefone ? `(${contact.dddTelefone}) ${contact.numTelefone}` : "Não informado"}</td>
          <td className="text-center align-middle">{contact.setor ? contact.setor : "Não informado"}</td>
          <td className="text-center align-middle">{contact.observacoes ? contact.observacoes : "Não informado"}</td>
          {this.props.currentUser.funcionalidades.includes(97) && (
            <td className="align-middle text-center">
              <div className="btn-group">
                <Link className="btn btn-sm btn-default" onClick={() => this.handleOnSelectContactClick(contact)} title="Editar">
                  <i className="far fa-edit"></i>
                </Link>
                <Link className="btn btn-sm btn-default" onClick={() => this.onActionDelete(this.setState({ contact: contact }))}>
                  <i className="fas fa-trash" title="Excluir"></i>
                </Link>
              </div>
            </td>
          )}
        </tr>
      );
    });
  }
}

const mapDispatchToProps = (dispatch) => ({
  onUfSystemLoad: (payload) => dispatch({ type: UF_SYSTEM_LOAD, payload }),
  onContactsLoad: (payload) => dispatch({ type: CONTACT_DETRAN_LIST_LOAD, payload }),
  onActionOpen: (payload) => dispatch({ type: CONFIRM_ACTION_OPEN, payload }),
  onContactsUnload: (payload) => dispatch({ type: CONTACT_DETRAN_LIST_UNLOAD, payload }),
});

const selector = formValueSelector("ContatosDetranForm");
const mapStateToProps = (state) => ({
  ...state.contatosDetran,
  selectedUf: selector(state, "uf"),
  currentUser: state.common.currentUser,
});

const form = reduxForm({
  form: "ContatosDetranForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(ContatosDetran));
